import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SessionsHeaders from './sessions_headers';

export default class TimePeriod extends Component {
  static propTypes = {
    ColumnHeaders: PropTypes.func.isRequired,
    Header: PropTypes.func.isRequired,
    // pagination: PropTypes.number,
    Session: PropTypes.func.isRequired,
    sessions: PropTypes.array.isRequired,
    time: PropTypes.string.isRequired,
  };

  // static defaultProps = {
  //   pagination: 4,
  // };

  // state = {
  //   currentPagination: 4,
  // };

  // paginate = e => {
  //   e.preventDefault();
  //   this.setState(({ currentPagination }, { pagination }) => ({
  //     currentPagination: currentPagination + pagination,
  //   }));
  // };

  // _renderPaginate() {
  //   return (
  //     <div className="weekly-pagination">
  //       <button onClick={this.paginate} className="button button-pagination">
  //         Load More{' '}
  //       </button>{' '}
  //     </div>
  //   );
  // }

  _renderSessions() {
    const { Session, sessions, time } = this.props;
    if (sessions.length < 1)
      return (
        <div className="cols-lg-12">
          <h5 className="no-sessions">There are no sessions this {time} </h5>{' '}
        </div>
      );

    return sessions.map(Session);
  }

  render() {
    const { ColumnHeaders, Header, sessions, time } = this.props;

    return (
      <section className={`panels ${time}`} key="items">
        <section className={`panels ${time}`} key="items">
          {Header(time)}
          <div className="table">
            {ColumnHeaders()}
            <div className="tbody">{this._renderSessions()}</div>
          </div>
        </section>
      </section>
    );
  }
}
